// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --color: #7A7A7A;
  --font-size: var(--font-size-xs);
  --font-weight: normal;
  --margin-bottom: 0;
  --size: 30px;
}

.checkbox-container {
  font-family: "DM Sans", sans-serif;
  margin-bottom: var(--margin-bottom);
}
.checkbox-container label {
  margin-bottom: 0;
}
.checkbox-container input[type=checkbox]:checked + .checkbox-content .checkbox-icon {
  box-shadow: 0 0 0 1px var(--ion-color-secondary);
  background-color: var(--ion-color-secondary);
}
.checkbox-container input[type=checkbox]:checked:disabled + .checkbox-content .checkbox-icon {
  box-shadow: 0 0 0 1px #B6B6B6;
  background-color: #B6B6B6;
}
.checkbox-container input[type=checkbox] + .checkbox-content {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
.checkbox-container input[type=checkbox] + .checkbox-content .checkbox-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: var(--size, 30px);
  height: var(--size, 30px);
  border-radius: 50%;
  box-shadow: 0 0 0 2px #d8e0ec;
  background-color: var(--ion-color-background);
  transition: all 0.2s;
}
.checkbox-container input[type=checkbox] + .checkbox-content .checkbox-icon ion-icon[checked=false] {
  color: var(--ion-color-background);
}
.checkbox-container input[type=checkbox] + .checkbox-content .checkbox-icon ion-icon {
  color: var(--ion-color-secondary-contrast);
  font-size: var(--font-size-h2);
}
.checkbox-container input[type=checkbox] + .checkbox-content .checkbox-text {
  display: block;
  margin-left: 10px;
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  color: var(--color);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/checkbox/checkbox.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,kCAAA;EACA,mCAAA;AACJ;AACI;EACI,gBAAA;AACR;AAKgB;EACI,gDAAA;EAEA,4CAAA;AAJpB;AAUqB;EACI,6BAAA;EACA,yBAAA;AARzB;AAcQ;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AAZZ;AAcY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EAEA,wBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,6BAAA;EACA,6CAAA;EAEA,oBAAA;AAfhB;AAkBoB;EACI,kCAAA;AAhBxB;AAcgB;EAKI,0CAAA;EACA,8BAAA;AAhBpB;AAoBY;EACI,cAAA;EACA,iBAAA;EAEA,+BAAA;EACA,2BAAA;EACA,mBAAA;AAnBhB","sourcesContent":[":host {\r\n    --color: #7A7A7A;\r\n    --font-size: var(--font-size-xs);\r\n    --font-weight: normal;\r\n    --margin-bottom: 0;\r\n    --size: 30px;\r\n}\r\n\r\n.checkbox-container {\r\n    font-family: \"DM Sans\", sans-serif;\r\n    margin-bottom: var(--margin-bottom);\r\n\r\n    label {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    input[type=\"checkbox\"] {\r\n        &:checked {\r\n            + .checkbox-content {\r\n                .checkbox-icon {\r\n                    box-shadow: 0 0 0 1px var(--ion-color-secondary);\r\n\r\n                    background-color: var(--ion-color-secondary);\r\n                }\r\n            }\r\n\r\n            &:disabled {\r\n                 + .checkbox-content {\r\n                     .checkbox-icon {\r\n                         box-shadow: 0 0 0 1px #B6B6B6;\r\n                         background-color: #B6B6B6;\r\n                     }\r\n                 }\r\n            }\r\n        }\r\n\r\n        + .checkbox-content {\r\n            display: flex;\r\n            flex-flow: row nowrap;\r\n            align-items: center;\r\n            justify-content: flex-start;\r\n\r\n            .checkbox-icon {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                flex-shrink: 0;\r\n\r\n                width: var(--size, 30px);\r\n                height: var(--size, 30px);\r\n\r\n                border-radius: 50%;\r\n                box-shadow: 0 0 0 2px #d8e0ec;\r\n                background-color: var(--ion-color-background);\r\n\r\n                transition: all .2s;\r\n\r\n                ion-icon {\r\n                    &[checked='false'] {\r\n                        color: var(--ion-color-background);\r\n                    }\r\n                    //COLORTODOcolor: var(--ion-color-primary);\r\n                    color: var(--ion-color-secondary-contrast);\r\n                    font-size: var(--font-size-h2);\r\n                }\r\n            }\r\n\r\n            .checkbox-text {\r\n                display: block;\r\n                margin-left: 10px;\r\n\r\n                font-weight: var(--font-weight);\r\n                font-size: var(--font-size);\r\n                color: var(--color);\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
